module.exports = __webpack_public_path__ + "img/Vitami_net.63322da6.jpg";